import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../shared/utils/utils'
import { DocumentUploadFormEdit } from "./document-upload-form/document-upload-form.component";
import { SupplierService } from '../../../core/services/person/supplier/supplier.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { MatProgressBar } from '@angular/material/progress-bar'



@Component({
  selector: 'document-upload-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    DocumentUploadFormEdit,
    MatSpinner
],
  templateUrl: './document-upload-edit.component.html',
  styleUrl: './document-upload-edit.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class DocumentUploadEditComponent implements OnInit, AfterViewInit {
  constructor(
    private supplierService:SupplierService 
  ) {}

  item: any = {}
  itemsList: any[] = []
  fileList: any[] = []
  contactList: any[] = []
  loading: any = false
  rows: number = 10
  page: number = 1

  @Input() idPerson: number = 0
  @Output() response: EventEmitter<any> = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'tipoDocDescricao',
      key: 'tipoDocDescricao',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'nomeArquivo',
      key: 'nomeArquivo',
      description: 'Documento',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'tipoDocDescricao',
    'descricao',
    'nomeArquivo',
    'action',
  ]

  ngOnInit(): void {
    this.getItem()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }


  getItem() {
    this.loading = true
    this.supplierService.listPagedSupplierDoc(this.idPerson,this.page ,this.rows).subscribe({
      next: (res) =>{
        if(res.data == 0 || res.data == null){
          this.itemsList.length = 0
        }else{
          this.itemsList = res.data
          this.tableSource = new MatTableDataSource<any>(this.itemsList)
        }
        this.loading = false
      },
      error: (err: any) => {
        console.error(err)
      }
    })
  }

  responseForm(element: any,  type: 'contact' | 'file') {
    console.log('action: ',element.action)
    switch (type){
      case 'contact':
        this.contactList = element.data
        break
      case 'file':
        this.fileList = element.data
        break
    }

    switch (element.action) {
      case 'create':
        this.includeItem(element)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  includeItem(element: any) {
    this.loading = true
    this.getItem()
    // this.itemsList.push({ ...element, idCreate: this.generateId() })
    // console.log("Lista atual: ",this.itemsList)
    // this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  updateItem(element: any) {
    this.loading = true
    this.getItem()
    // let index = this.itemsList.findIndex((ele: any) => {
    //   return ele.idCreate == element.idCreate
    // })
    // this.itemsList.splice(index, 1, (({ index, ...rest }) => rest)(element))
    // this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    // this.item = {}
    // this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    
    this.supplierService.deleteDocSupplier(element.id).subscribe({
      next: (res) => {
        this.getItem()
        this.loading = false
      },
      error: (err: any) => {
        console.error(err)
      }
    })
    // let index = this.itemsList.findIndex((ele: any) => {
    //   return ele.idCreate == element.idCreate
    // })
    // if (index >= 0) {
    //   this.item = {}
    //   this.itemsList.splice(index, 1)
    //   this.tableSource = new MatTableDataSource<any>(this.itemsList)
    //   this.refreshTable()
    //   this.response.emit(this.itemsList)
    // }
  }

  selectItemEvent(element: any) {
    this.item = element
  }
}
